function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M10 1.29c4.783 0 8.71 3.874 8.71 8.71 0 4.81-3.896 8.71-8.71 8.71A8.707 8.707 0 0 1 1.29 10 8.71 8.71 0 0 1 10 1.29zM10 0C4.478 0 0 4.48 0 10c0 5.524 4.478 10 10 10s10-4.476 10-10c0-5.52-4.478-10-10-10zm-.463 4.839h.926c.275 0 .495.229.484.504l-.283 6.774a.484.484 0 0 1-.483.464h-.362a.484.484 0 0 1-.484-.464l-.282-6.774a.484.484 0 0 1 .484-.504zM10 13.387a1.129 1.129 0 1 0 0 2.258 1.129 1.129 0 0 0 0-2.258z"
});

var SvgWarningCircleInline = function SvgWarningCircleInline(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgWarningCircleInline;